<template>
  <div class="full-height" style="padding: 20px; padding-bottom: 0; height: 100%">
    <div style="padding-bottom: 0">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item label="搜尋">
          <el-input
            size="mini"
            v-model="listQuery.qry"
            placeholder="輸入查詢"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            size="mini"
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
          >
            搜尋
          </el-button>

          <el-button type="success" size="mini" @click="addData">建立</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column align="center" label="ID" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="圖片" width="200">
          <template slot-scope="scope">
            <el-image
              style="height: 50px"
              :src="
                scope.row.fileInfo.length > 0
                  ? scope.row.fileInfo[0].files[0].url
                  : 'https://fakeimg.pl/420x250/'
              "
              fit="contain"
              :preview-src-list="fileUrl(scope.row.fileInfo)"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" label="標題" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="描述" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.introduction }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="外部連結" width="250">
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank">
              <span style="color: rgb(64, 158, 255)">{{ scope.row.url }}</span>
            </a>
            <!-- <span>{{ scope.row.url }}</span> -->
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" label="排序" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.sort }}</span>
          </template>
        </el-table-column> -->

        <el-table-column align="center" label="編輯" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editData(scope.row)">編輯</el-button>
          </template>
        </el-table-column>

        <el-table-column label="刪除" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="handleDelete(scope)">刪除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      style="padding-top: 0; margin-top: 15px"
      v-show="total > 0"
      layout="total, prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />

    <el-dialog
      @closed="onDialogClosed"
      :title="'編輯'"
      :visible.sync="dialogFormVisible"
      width="90%"
      top="1%"
      style="border: 2px solid #ccc"
    >
      <el-card class="box-card" v-loading="formLoading" :body-style="{ border: '1px solid #ccc' }">
        <el-row>
          <el-col>
            <el-form ref="dynamicValidateForm" :model="formData">
              <el-form-item label="圖片" :label-width="formLabelWidth">
                <div>
                  <Upload
                    ref="uploadRef"
                    :accept="'.jpg,.jpeg,.png'"
                    :payload="formData"
                    :data-obj="fileObj"
                    :limitText="'圖片尺寸:420x250，須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
                    :limit-file-count="1"
                    :use-drag="false"
                    :action="'ToursCombine/saveHotCountry'"
                    :auto-upload="false"
                    :show-file-list="true"
                    :form-on-loading-parent="formLoading"
                    :btn-txt="'上傳'"
                    :before-file-list="coverFileList"
                  />
                </div>
              </el-form-item>

              <el-form-item
                label="標題"
                :label-width="formLabelWidth"
                prop="title"
                :rules="[
                  {
                    required: true,
                    message: '請輸入標題',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="formData.title" autocomplete="off" />
              </el-form-item>

              <el-form-item label="描述" :label-width="formLabelWidth" prop="introduction">
                <el-input
                  v-model="formData.introduction"
                  autocomplete="off"
                  maxlength="50"
                  show-word-limit
                />
              </el-form-item>

              <el-form-item label="外部連結" :label-width="formLabelWidth" prop="title">
                <el-input v-model="formData.url" autocomplete="off" />
              </el-form-item>

              <el-form-item label="內容" :label-width="formLabelWidth" prop="articleContent">
                <div>
                  <tinymce
                    ref="tinymce"
                    v-model="formData.articleContent"
                    :height="500"
                    :type="29"
                  />
                </div>
              </el-form-item>

              <el-form-item
                label="發文日期"
                :label-width="formLabelWidth"
                prop="buildDate"
                :rules="[
                  {
                    required: true,
                    message: '請選擇發文日期',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-date-picker
                  v-model="formData.buildDate"
                  type="date"
                  placeholder="請選擇發文日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>

              <!-- <el-form-item
                  label="排序"
                  :label-width="formLabelWidth"
                  prop="sort"
                  :rules="[
                    {
                      required: true,
                      message: '請輸入排序',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    v-model="formData.sort"
                    autocomplete="off"
                    type="number"
                  />
                </el-form-item> -->
            </el-form>
          </el-col>
        </el-row>
      </el-card>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveData('dynamicValidateForm')">儲 存</el-button>
        <el-button @click="onDialogClosed">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { Message } from 'element-ui'
import checkPermission from '@/utils/permission' // 权限判断函数
import Upload from '@/views/ita/components/fileUpload.vue'
import Tinymce from '@/components/Tinymce'
import { deleteNewsArticle, getNewsArticle, saveNewsArticle } from '@/api/ita'
import { encodeContentBase64 } from '@/utils/funcs'

var defaultData = {
  id: null,
  fileInfo: [],
  sort: 99,
  title: '',
  url: '',
  articleContent: '',
  introduction: '',
  buildDate: new Date(),
}

export default {
  components: {
    Pagination,
    Upload,
    Tinymce,
  },
  computed: {
    // 只把「伺服器上已存在的封面檔」(帶 id) 傳給上傳元件。
    // combineFileAndPayload 會把新選的檔案(無 id 的 base64 物件)寫回 formData.fileInfo，
    // 若原封傳回子元件，其 watcher 會以 uid=undefined 建出幽靈檔案，
    // 再被 element-ui 補上假 uid 混進 fileIDs 送往後端。過濾掉即可根除。
    coverFileList() {
      const info = this.formData.fileInfo
      if (!info || !info.length || !info[0].files) {
        return []
      }
      return info[0].files.filter(f => f.id !== undefined && f.id !== null)
    },
    fileUrl() {
      return function (array) {
        if (array.length) {
          var list = array[0].files.map(x => {
            return x.url
          })
          return list
        } else {
          return ['https://fakeimg.pl/280x160/']
        }
      }
    },
  },
  data() {
    return {
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      formLoading: false,
      formData: {},
      listLoading: false,
      list: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      listQuery: {
        page: 1,
        limit: 30,
        sort: '-BuildDate',
      },
      total: 0,
    }
  },
  async created() {
    await this.getList()
  },
  methods: {
    checkPermission,

    async getList() {
      this.listLoading = true
      await getNewsArticle(this.listQuery)
        .then(respoonse => {
          console.log(respoonse)
          this.list = respoonse.data.data
          this.total = respoonse.data.total
          this.listLoading = false
        })
        .catch(error => {
          this.listLoading = false
        })
    },
    addData() {
      let vm = this
      vm.formData = JSON.parse(JSON.stringify(defaultData))
      vm.dialogFormVisible = true
      vm.loadTinymceContent('')
    },
    editData(d) {
      console.log(d)
      const vm = this
      //複製物件
      let jData = JSON.parse(JSON.stringify(d))
      vm.formData = jData
      vm.dialogFormVisible = true
      vm.loadTinymceContent(jData.articleContent)
    },
    // Tinymce 元件的 hasChange 被 SetContent 事件設為 true 後不會還原(index.vue:192)，
    // 導致其 value watcher 永久失效(index.vue:95)，第二次開啟對話框時內文載不進來，
    // 必須整頁重新整理才會恢復。這裡直接呼叫 setValue 繞過 watcher。
    // 首次開啟時編輯器尚未初始化(hasInit=false)，由 init_instance_callback 自行帶入內容。
    loadTinymceContent(content) {
      const vm = this
      vm.$nextTick(() => {
        const editor = vm.$refs['tinymce']
        if (editor && editor.hasInit) {
          editor.setValue(content || '')
        }
      })
    },
    async saveData(formName) {
      console.log(this.formData)
      const vm = this
      if (!confirm(`確定要儲存資料?`)) {
        return false
      }
      let refUpload = this.$refs['uploadRef']
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }
          // 編輯既有資料且未重選封面時，fileUpload 不會 push fileModel，fileInfo 為空陣列，
          // 直接取 [0] 會 TypeError。改為「新檔或舊檔至少要有一張」。
          // 另濾掉無效的舊檔 ID，避免空值被當成「有舊圖」而誤放行。
          // （webpack4/babel 不支援 optional chaining，只能用 && 判斷）
          const oldIDs = (payload.fileIDs || []).filter(
            id => id !== undefined && id !== null && id !== ''
          )
          payload.fileIDs = oldIDs
          const hasNewFile = payload.fileInfo && payload.fileInfo.length > 0
          if (!hasNewFile && oldIDs.length === 0) {
            this.$message.error('請上傳圖片')
            return false
          }
          if (payload.articleContent == '' && payload.url == '') {
            this.$message.error('請設定外部連結或文章內文')
            return false
          }
          vm.formLoading = true
          // 標題與富文本內文 base64 編碼(避免 AWS WAF 誤擋 403)；用複製物件避免污染響應式 formData
          // （payload 為 formData 參照）。後端 Base64ContentCodec.Decode 還原後再存檔。
          await saveNewsArticle({
            ...payload,
            title: encodeContentBase64(payload.title),
            articleContent: encodeContentBase64(payload.articleContent),
          })
            .then(async resp => {
              vm.onDialogClosed()
              vm.formLoading = false
              await vm.getList()
              Message({
                message: '資料處理完成',
                type: 'success',
                duration: 5 * 1000,
              })
            })
            .catch(() => {
              vm.onDialogClosed()
              vm.formLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onDialogClosed() {
      let refUpload = this.$refs['uploadRef']
      refUpload.clearFiles()
      this.$refs['dynamicValidateForm'].clearValidate()
      this.formData = JSON.parse(JSON.stringify(defaultData))
      this.loadTinymceContent('') //重置內容(含編輯器未初始化的守衛)
      this.dialogFormVisible = false
    },
    handleDelete({ $index, row }) {
      console.log($index, row)
      this.$confirm('確定刪除該筆資料?', '警告', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.listLoading = true
          await deleteNewsArticle({ id: row.id })
          await this.getList()
          this.listLoading = false
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
  },
}
</script>
